<app-button-group>
  <button buttonType="flat" buttonTheme="light" app-button [selected]="(viewMode$ | async) === galleryViewMode.Cards" (click)="handleViewModeClick(galleryViewMode.Cards)">
      <app-icon icon="th"></app-icon>
  </button>
  
  <button buttonType="flat" buttonTheme="light" app-button [selected]="(viewMode$ | async) === galleryViewMode.List" (click)="handleViewModeClick(galleryViewMode.List)">
      <app-icon icon="bars"></app-icon>
  </button>
  
</app-button-group>